import React, { Component } from "react";
import "./style.less";
import axios from 'axios/dist/axios.min.js'
import utils from "../../../../utils/utils";
class Games extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgArr1: [
        "https://static.shihuocdn.cn/admin/files/20210907/82ce2556596ff7fcc5e6e5ca66ea9e40.png",
        "https://static.shihuocdn.cn/admin/files/20210907/94e649f5356f3b4ddd9f71a6c3d56cd5.png",
        "https://static.shihuocdn.cn/admin/files/20210907/c5b071097df9e12690078955df506b1f.png",
        "https://static.shihuocdn.cn/admin/files/20210907/9169ca1c671e7d445e0de1676c689a98.png",
        "https://static.shihuocdn.cn/admin/files/20210907/9169ca1c671e7d445e0de1676c689a98.png",
        "https://static.shihuocdn.cn/admin/files/20210907/3a35f1348612e52f6ff39f6f32b19490.png",
        "https://static.shihuocdn.cn/admin/files/20210907/0801d119d1fb259da0b905f4c50703a8.png",
        "https://static.shihuocdn.cn/admin/files/20210907/5d8940af9f2c2b015303bc09319ae390.png",
        "https://static.shihuocdn.cn/admin/files/20210907/7c6738acddcc88dac915d7e5ccf5b6b5.png",
        "https://static.shihuocdn.cn/admin/files/20210907/54c0ba61ae7b019a36ad80aa831cb867.png",
        "https://static.shihuocdn.cn/admin/files/20210907/04a52f367a8a4e436ed7de664c74418b.png",
        "https://static.shihuocdn.cn/admin/files/20210907/8a1e3fff48d14a930dd8ab353755f22f.png",
        "https://static.shihuocdn.cn/admin/files/20210907/38310b4ada4906bdab8a3462c415c7e4.png",
        "https://static.shihuocdn.cn/admin/files/20210907/e1bffc3ddfedd89b915e2ebebe44096b.png",
        "https://static.shihuocdn.cn/admin/files/20210907/87f71e4f2d29135bc37bdd027e06696f.png",
        "https://static.shihuocdn.cn/admin/files/20210907/0b32ef3a542b0f5433f4dc1e250ba8d2.png",
        "https://static.shihuocdn.cn/admin/files/20210907/9835834a0b8ec7c5f7b6193b88267a6e.png",
        "https://static.shihuocdn.cn/admin/files/20210907/80744784a64659c943f5bfca9ed8e89a.png",
        "https://static.shihuocdn.cn/admin/files/20210907/35fe619526d62ecbf036dd3501b50771.png",
        "https://static.shihuocdn.cn/admin/files/20210907/81c7fee295647bdc3e8675bec79e7119.png",
        "https://static.shihuocdn.cn/admin/files/20210908/9db6482505ac903990d730bc7ca0ce03.png",
        "https://static.shihuocdn.cn/admin/files/20210908/08f2b1aec1e70c1bbdf2a693365e8b6c.png"
      ],
      imgArr2: [
        "https://static.shihuocdn.cn/admin/files/20210908/77566000069baafbed7d89b4fb3fc206.png",
        "https://static.shihuocdn.cn/admin/files/20210908/2cd44548695e39639ee361e153fb8983.png",
        "https://static.shihuocdn.cn/admin/files/20210908/b8b7391cee5935ab0d7f1f32aaf98a34.png",
        "https://static.shihuocdn.cn/admin/files/20210908/4ec2a8e71b4342e4abb5a5694d31b9b1.png",
        "https://static.shihuocdn.cn/admin/files/20210908/2c90b3d808ee47b8b50ebabf1b7870b9.png",
        "https://static.shihuocdn.cn/admin/files/20210908/c81d70631001d3923de496310e79da48.png",
        "https://static.shihuocdn.cn/admin/files/20210908/4e285cdf846e370228515c513ea52efe.png",
        "https://static.shihuocdn.cn/admin/files/20210908/42d3ce02e783117edc6104771a7e8354.png",
        "https://static.shihuocdn.cn/admin/files/20210908/ccd21aea264cf442938fcc31cefcba0a.png",
        "https://static.shihuocdn.cn/admin/files/20210908/7a40264b440a10a6742d9b72902c558f.png",
        "https://static.shihuocdn.cn/admin/files/20210908/1f90577f7000ce1b7e757e9a33ba177b.png",
        "https://static.shihuocdn.cn/admin/files/20210908/b5eb017f7cd0f44bb924fd9bb2338155.png",
        "https://static.shihuocdn.cn/admin/files/20210908/e3493e93eb06ca221c84debfd4d9d071.png",
        "https://static.shihuocdn.cn/admin/files/20210908/87292e9f262a72a627d6078ff44a0c43.png",
        "https://static.shihuocdn.cn/admin/files/20210908/c61e312ddeafa3a8c3ae8cabc7b25c95.png",
        "https://static.shihuocdn.cn/admin/files/20210908/86f6d9b738a3852fa1e6164531143c91.png",
        "https://static.shihuocdn.cn/admin/files/20210908/609b26329abcc335423e7899924b42eb.png",
        "https://static.shihuocdn.cn/admin/files/20210908/ff3e2c94fe786f056d58f2f13ceacd1b.png",
        "https://static.shihuocdn.cn/admin/files/20210908/b013d24b2612d8c64dfc16deeddc9310.png"
      ],
      prizeShow: false
    };
    this.framePlayer1 = null;
    this.framePlayer2 = null;
  }
  componentDidMount() {
    const app_version = utils.getVersion();
    if (typeof window !== 'undefined' && app_version && utils.SHDiffVersion(app_version, '6.71.0')) {
      window.Jockey.send("uploadExposures", {
        list: [`${this.props.unique_id}.be..topic_page_game_sale.draw_gift.......`]
      }, () => {}); 
    }

    const { imgArr1, imgArr2 } = this.state;
    this.loadFramePlayer(imgArr1, imgArr2);
    
    setTimeout(() => {
      this.playGames();
      this.setState({
        prizeShow: true
      })
    }, 500)
  }

  shouldComponentUpdate(nextProps) {
    const { prize_list, info, startSlotMachine } = nextProps;
    if (this.props.startSlotMachine != startSlotMachine) {
      prize_list.forEach((item, index) => {
        if (item.prize_name && info.prize_name && (item.prize_name == info.prize_name)) {
          this.stopIndex = index;
          this.startFramePlayer1(0, 264, this.state.imgArr1)
        }
      }) 
    }

    return true
  }

  playGames = () => {
    const casino1 = document.querySelector('#casino1');
    const casino2 = document.querySelector('#casino2');
    const casino3 = document.querySelector('#casino3');

    this.mCasino1 = new window.SlotMachine(casino1, {
      active: 0,
      delay: 400,
      transition: "ease-in-out",
      direction: "down",
      onComplete: () => {
        this.mCasino2.stop();
      }
    });
    this.mCasino2 = new window.SlotMachine(casino2, {
      active: 1,
      delay: 500,
      transition: "ease-in-out",
      direction: "down",
      onComplete: () => {
        this.mCasino3.stop();
      }
    });
    this.mCasino3 = new window.SlotMachine(casino3, {
      active: 2,
      delay: 600,
      transition: "ease-in-out",
      direction: "down",
      onComplete: () => {
        setTimeout(() => {
          document.getElementsByClassName("result")[0].style.display = "flex";
          this.startFramePlayer2(0, 228, this.state.imgArr2)
        }, 300);
      }
    });
  }
  
  gameClose(from, block) {
    if (typeof window !== 'undefined' && from && block) {
      window.__dace.sendEvent(block, {
        from,
        block
      });
    }
    this.props.closeGame();
  }

  render() {
    const { prizeShow } = this.state;
    const { visable, prize_list } = this.props;
    const { prize_pic } = this.props.info;
    
    if (!visable) {
      return null;
    }
    return (
      <div className="game-dialog">
        <div className="mask"></div>
        <div className="game-content luck">
          <div className="framePlayer1" onClick={() => this.props.handleLuckyDraw()}></div>
          <img src="https://static.shihuocdn.cn/admin/files/20210907/82ce2556596ff7fcc5e6e5ca66ea9e40.png" alt="" className="first-frame" />
          <ul className="prize-wrap">
            <li id="casino1" className={prizeShow ? 'show' : 'hide'}>
              {
                prize_list && prize_list.length > 0 && prize_list.map((item, index) => {
                  if (item.prize_pic && item.prize_pic[0]) {
                    return <img src={item.prize_pic[0]} alt="" className={`slot slot${index}`} key={index} />
                  } else {
                    return null
                  }
                })
              }
            </li>
            <li id="casino2" className={prizeShow ? 'show' : 'hide'}>
              {
                prize_list && prize_list.length > 0 && prize_list.map((item, index) => {
                  if (item.prize_pic && item.prize_pic[0]) {
                    return <img src={item.prize_pic[0]} alt="" className={`slot slot${index}`} key={index} />
                  } else {
                    return null
                  }
                })
              }
            </li>
            <li id="casino3" className={prizeShow ? 'show' : 'hide'}>
              {
                prize_list && prize_list.length > 0 && prize_list.map((item, index) => {
                  if (item.prize_pic && item.prize_pic[0]) {
                    return <img src={item.prize_pic[0]} alt="" className={`slot slot${index}`} key={index} />
                  } else {
                    return null
                  }
                })
              }
            </li>
          </ul>
        </div>
        <div className="game-content result">
          <div className="framePlayer2" onClick={() => this.handleGetPrizes()}></div>
          <img src={(prize_pic && prize_pic[0]) || prize_pic} alt="" className="prize" onClick={() => this.handleGetPrizes()} />
        </div>
        <img src="https://static.shihuocdn.cn/admin/files/20210912/e596e2c89d336b492bd4b2c40fe573dc.png" alt="" className="close" onClick={() => this.gameClose('topic_page_game_sale', 'close_draw')} />
      </div>
    )
  }

  loadImages({loadArr, complete}) {
    var sources = loadArr;
    var loadingPercent = "";
    var count = 0;
    var images = {};
    var imgNum = sources.length;
    for (var src in sources) {
      var path = src;
      images[path] = new Image();
      images[path].onload = function () {
        count++;
        if (count >= imgNum) {
          complete(images);
        }
      };
      images[path].onerror = function () {
        count++;
        if (count >= imgNum) {
          complete(images);
        }
      };
      images[path].src = sources[path];
    }
  }

  loadFramePlayer(imgArr1, imgArr2) {
    this.loadImages({
      loadArr: imgArr1,
      complete: () => {
        this.framePlayer1 = new window.vFramePlayer({
          dom: document.getElementsByClassName("framePlayer1")[0],
          imgArr: imgArr1,
          useCanvas: true
        });

        this.framePlayer1.on("play", () => {

        });
      }
    })

    this.loadImages({
      loadArr: imgArr2,
      complete: () => {
        this.framePlayer2 = new window.vFramePlayer({
          dom: document.getElementsByClassName("framePlayer2")[0],
          imgArr: imgArr2,
          useCanvas: true
        });

        this.framePlayer2.on("play", () => {

        });
      }
    })
  }

  // 开始播放序列帧1
  startFramePlayer1(start, end, imgArr) {
    this.framePlayer1.play(start, end, {
      fps: 12,
      onComplete : () => {
        this.framePlayer1.stop();
      },
      onUpdate : (frame, times, asc) => {
        document.getElementsByClassName("first-frame")[0].style.display = "none";
        if (frame >= imgArr.length - 1) {
          this.framePlayer1.stop();
          this.mCasino1.shuffle(10, this.stopIndex);
          this.mCasino2.shuffle(10, this.stopIndex);
          this.mCasino3.shuffle(10, this.stopIndex);

          setTimeout(() => {
            this.mCasino1.stop();
          }, 3000);
        }
      }}
    )
  }

  // 开始播放序列帧2
  startFramePlayer2(start, end, imgArr) {
    const luckStyle = document.getElementsByClassName("luck")[0].style;
    const prizeStyle = document.getElementsByClassName("prize")[0].style;
    this.framePlayer2.play(start, end, {
      fps: 12,
      onComplete : () => {
        this.framePlayer2.stop();
      },
      onUpdate : (frame, times, asc) => {
        if (frame >= 3 && luckStyle.display != "none") {
          luckStyle.display = "none";
        }
        if (frame >= 5) {
          prizeStyle.display = "block";
        }
        if (frame >= imgArr.length - 1) {
          this.framePlayer2.stop();
        }
      }}
    )
  }

  handleGetPrizes() {
    if (typeof window !== 'undefined') {
      window.__dace.sendEvent('quick_acquire', {
        from: "topic_page_game_sale",
        block: "quick_acquire"
      }); 
    }
    const { isLogin } = this.props;
    const { prize_type, jump_url, record_id, recevied } = this.props.info;
    switch (prize_type) {
      case 2:
        // 淘礼金
        if (recevied == 0) {
          // 领取淘礼金
          this.getCoupons(record_id);
        } else {
          jump_url && window.Jockey.send("action", {
            url: jump_url
          });
          this.gameClose();
        }
        break;
      case 4:
        // 生活服务券
        if (!isLogin) {
          this.props.login();
          return;
        }
        if (recevied == 0) {
          // 领券
          this.getCoupons(record_id);
        } else {
          window.Jockey.send("action", {
            url: jump_url
          });
          this.gameClose();
        }
        break;
      case 5:
        // 返现券
        if (recevied == 0) {
          // 领券
          this.getCoupons(record_id);
        } else {
          window.Jockey.send("action", {
            url: jump_url
          });
          this.gameClose();
        }
        break;
      default:
        break;
    }
  }

  // 领券
  getCoupons = (record_id) => {
    const { unique_id, abtest_tag } = this.props;
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-luckydrawapi/new_draw/get?unique_id=' + unique_id,
      method: 'post',
      withCredentials: true,
      data: {
        id: record_id,
      },
      headers: {
        "Abtest-Control": abtest_tag,
      }
    }).then(res => {
      const { status, msg, data } = res.data;
      if (status == 0) {
        this.props.showToast(true, "领取成功");
        this.props.queryWinningRecord();
        this.gameClose();

        if (data && data.jump_url) {
          window.Jockey.send("action", {
            url: data.jump_url
          });
        }
      } else {
        this.props.showToast(true, "领取失败，请联系客服人员");
      }
    })
  }
}

export default Games;



// WEBPACK FOOTER //
// ./components/pipeline-games/components/Games/index.js